import ENV from "../../env/env.json";

export const firebaseConfig = ENV.firebaseConfig;
export const baseURL = ENV.baseURL;
export const environment = ENV.environment;
export const PAGE_SIZE = 50;
export const IS_DEV = environment === "Development";
